module.exports = __webpack_public_path__ + "static/media/letsemp.5ba71c7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/revised/letsemp.png
// module id = 88
// module chunks = 19